export const convertToObject = (array, key) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

export const convertToKeyValues = (array, key, value) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item[value],
    };
  }, initialValue);
};

export const moveItem = (list, fromIndex, toIndex) => {
  //const list = Array.from(array);
  const [removed] = list.splice(fromIndex, 1);
  list.splice(toIndex, 0, removed);

  return list;
};

export const removeItem = (list, index) => {
  //const list = Array.from(array);
  list.splice(index, 1);

  return list;
};

export const find = (list, fn) => {
  if (!list) return null;
  for (let i = 0; i < list.length; i++) {
    if (fn(list[i])) {
      return list[i];
    }
  }
};

export const caseInsensitiveCompare = function (a, b) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}

// put the null items at the end.
export const compareIgnoreEmpty = function (asc) {
  return asc ?
    function (a, b) {
      return (a === null || isNaN(a)) - (b === null || isNaN(b)) || +(a > b) || -(a < b);
    }
    :
    function (a, b) {
      return (a === null || isNaN(a)) - (b === null || isNaN(b)) || -(a > b) || +(a < b);
    }
}